import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paperWidthSm': {
      width: 'calc(100vw - 30px)',
      height: '500px',
      maxWidth: '500px',
      minWidth: '350px'
    }
  },
  contentWrapper: {
    padding: '10px',
    height: '0px',
    '. div': {
      width: '100%',
      height: '500px'
    }
  }
}));
